<script setup lang="ts">
import { InputGroup, InputGroupAddon, Select } from 'primevue';
import { computed } from 'vue';
import { useMapStyleStore } from 'shared/mapStyles/stores/mapStyleStore';
import { storeToRefs } from 'pinia';
import {
  IconSharpColorLens
} from '@iconify-prerendered/vue-ic';

const store = useMapStyleStore();
const { selectedStyleId } = storeToRefs(store);
const options = computed(() => store.styles);
</script>

<template>
  <InputGroup v-if="options.length > 0" class="style-select">
    <InputGroupAddon>
      <IconSharpColorLens></IconSharpColorLens>
    </InputGroupAddon>
    <Select v-model:model-value="selectedStyleId" option-value="id" option-label="name"
      :options="options">
    </Select>
  </InputGroup>
</template>

<style scoped>
.style-select {
  width: unset;
  min-width: 10rem;
}
</style>
